import { PRIORITY_CONFIG } from "@/features/tickets/config";
import { Priority } from "@/features/tickets/types";
import { cn } from "@/shared/lib/utils/cn";

interface Props {
  value: Priority;
  onChange: (priority: Priority) => void;
  disabled?: boolean;
}

export function PrioritySelector({ value, onChange, disabled }: Props) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {(Object.entries(PRIORITY_CONFIG) as [Priority, (typeof PRIORITY_CONFIG)[Priority]][]).map(([priority, cfg]) => {
        const Icon = cfg.icon;
        const selected = value === priority;
        return (
          <button
            key={priority}
            type="button"
            onClick={() => onChange(priority)}
            disabled={disabled}
            className={cn("flex items-center gap-2.5 border px-3 py-2.5 text-left transition-colors", selected ? cn(cfg.bg, cfg.className) : "border-border bg-card text-muted-foreground hover:bg-accent hover:text-foreground", disabled && "pointer-events-none opacity-50")}
          >
            <Icon className={cn("size-3.5 shrink-0", selected && cfg.className)} />
            <div className="min-w-0">
              <p className="text-xs font-semibold truncate">{priority}</p>
              <p className="text-[10px] text-muted-foreground leading-tight truncate">{cfg.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
